import axios from "axios";

export const getTransactions = async (page = 1, filters = {}) => {
  try {
    const brear = localStorage.getItem("token");
    console.log("brear", brear);
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get("/v1/admin/transactions", {
      params: {
        page,
         transactionable_id:filters.store_id,
      transactionable_type:filters.store_id?"store":""
        ,
        ...filters
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCourierTransactions = async (page = 1, courier_id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");

    const { data } = await axios.get("/v1/admin/transactions", {
      params: {
        page,
        transactionable_id: courier_id,
        transactionable_type: "courier", // 👈 ثابت للكورير
      },
      headers: {
        Authorization: "Bearer " + brear,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
}